import { Card, DialogTrigger, mergeClasses, Text } from "@fluentui/react-components";
import useStyleUtils from "../../utilities/styles";
import { Col, Container, Row } from "react-grid-system";
import { Add48Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import styles from "./NewFolderCard.module.scss";

export default function NewFolderCard() {
    const { t } = useTranslation();
    const style = useStyleUtils();

    const cardStyles = mergeClasses(styles.card, style.mb3, style.justifyContentCenter);

    return (
       <DialogTrigger disableButtonEnhancement>
            <Card className={cardStyles}>
                <Container fluid={true}>
                    <Row align='center'>
                        <Col xs={12} className={style.textCenter}>
                            <Text size={800}>
                                <Add48Regular />
                            </Text>
                        </Col>
                        <Col xs={12} className={style.textCenter}>
                            <Text size={400}>
                                {t("folders.titles.create")}
                            </Text>
                        </Col>
                    </Row>
                </Container>
            </Card>
        </DialogTrigger>
    );
}